(() => {
  const D = window.Dallas || {};
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------- Drawers ---------- */
  const cartDrawer = $('[data-cart-drawer]');
  const wishlistDrawer = $('[data-wishlist-drawer]');
  const drawers = [cartDrawer, wishlistDrawer].filter(Boolean);

  const setDrawer = (drawer, open) => {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('no-scroll', open);
    const panel = drawer.querySelector('.drawer__panel');
    if (open && panel) {
      setTimeout(() => panel.focus(), 50);
    }
  };

  const closeAll = () => {
    drawers.forEach((d) => setDrawer(d, false));
  };

  const openCart = () => {
    closeAll();
    setDrawer(cartDrawer, true);
    if (window.DallasCart && typeof window.DallasCart.refresh === 'function') {
      window.DallasCart.refresh();
    }
  };

  const openWishlist = () => {
    closeAll();
    setDrawer(wishlistDrawer, true);
    renderWishlist();
  };

  document.addEventListener('click', (e) => {
    const cartTrigger = e.target.closest('[data-action="open-cart"]');
    const wishlistTrigger = e.target.closest('[data-action="open-wishlist"]');
    const closeBtn = e.target.closest('[data-drawer-close]');
    const overlay = e.target.closest('.drawer__overlay');

    if (cartTrigger) {
      e.preventDefault();
      openCart();
    } else if (wishlistTrigger) {
      e.preventDefault();
      openWishlist();
    } else if (closeBtn || overlay) {
      closeAll();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  /* ---------- Mobile menu ---------- */
  const header = $('[data-header]');
  if (header) {
    const toggleBtn = $('[data-action="toggle-menu"]', header);
    const menu = $('[data-mobile-menu]', header);
    const iconOpen = $('[data-menu-icon-open]', header);
    const iconClose = $('[data-menu-icon-close]', header);

    if (toggleBtn && menu) {
      toggleBtn.addEventListener('click', () => {
        const open = menu.hasAttribute('hidden');
        menu.toggleAttribute('hidden', !open);
        toggleBtn.setAttribute('aria-expanded', String(open));
        if (iconOpen) iconOpen.toggleAttribute('hidden', open);
        if (iconClose) iconClose.toggleAttribute('hidden', !open);
      });
    }

    $$('[data-mobile-menu-link]', header).forEach((link) => {
      link.addEventListener('click', () => {
        if (menu) menu.setAttribute('hidden', '');
        toggleBtn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- Language / country selectors ---------- */
  const submitLocalization = (select) => {
    if (!select) return;
    const form = select.closest('form');
    if (!form) return;
    const fieldName = select.hasAttribute('data-language-select') ? 'locale_code' : 'country_code';
    const input = form.querySelector(`input[name="${fieldName}"]`);
    if (input) input.value = select.value;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  };

  document.addEventListener('change', (e) => {
    const languageSelect = e.target.closest('[data-language-select]');
    const countrySelect = e.target.closest('[data-country-select]');
    if (languageSelect) submitLocalization(languageSelect);
    else if (countrySelect) submitLocalization(countrySelect);
  });

  /* ---------- Cookie consent ---------- */
  const consent = $('.cookie-consent');
  if (consent) {
    const KEY = 'dallas-cookie-consent';
    let accepted = null;
    try {
      accepted = localStorage.getItem(KEY);
    } catch (_) {
      /* ignore */
    }
    if (!accepted) {
      setTimeout(() => consent.removeAttribute('hidden'), 1500);
    }
    $('[data-cookie-accept]')?.addEventListener('click', () => {
      try {
        localStorage.setItem(KEY, 'accepted');
      } catch (_) {
        /* ignore */
      }
      consent.setAttribute('hidden', '');
    });
    $('[data-cookie-decline]')?.addEventListener('click', () => {
      try {
        localStorage.setItem(KEY, 'declined');
      } catch (_) {
        /* ignore */
      }
      consent.setAttribute('hidden', '');
    });
  }

  /* ---------- Wishlist ---------- */
  const WISH_KEY = 'dallas-wishlist';
  let wishlistEmptyHtml = '';
  const wishlistBody = $('[data-wishlist-drawer-body]');
  if (wishlistBody) {
    wishlistEmptyHtml = wishlistBody.innerHTML;
  }

  const loadWishlist = () => {
    try {
      const raw = localStorage.getItem(WISH_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (_) {
      return [];
    }
  };

  const saveWishlist = (list) => {
    try {
      localStorage.setItem(WISH_KEY, JSON.stringify(list));
    } catch (_) {
      /* ignore */
    }
  };

  const updateWishlistUI = () => {
    const list = loadWishlist();
    const count = list.length;
    $$('[data-wishlist-count]').forEach((el) => {
      el.textContent = count;
      el.toggleAttribute('hidden', count === 0);
    });
    $$('[data-wishlist-toggle]').forEach((btn) => {
      const handle = btn.dataset.productHandle;
      const isWished = list.some((i) => i.handle === handle);
      btn.classList.toggle('is-wished', isWished);
      btn.setAttribute('aria-pressed', String(isWished));
    });
  };

  const renderWishlist = () => {
    const drawer = $('[data-wishlist-drawer]');
    if (!drawer) return;
    const body = $('[data-wishlist-drawer-body]', drawer);
    const countEl = $('[data-wishlist-drawer-count]', drawer);
    const list = loadWishlist();

    countEl.textContent = list.length ? ` (${list.length})` : '';

    if (!list.length) {
      body.innerHTML = wishlistEmptyHtml;
      return;
    }

    body.innerHTML = list
      .map(
        (item) => `
        <div class="cart-line" data-wishlist-line>
          <div class="cart-line__media">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : '<div class="cart-line__media--placeholder"></div>'}
          </div>
          <div class="cart-line__info">
            <div>
              <a href="${item.url}" class="cart-line__name">${item.title}</a>
              <p class="cart-line__meta">${formatMoney(item.price)}</p>
            </div>
          </div>
          <button type="button" class="cart-line__remove" data-wishlist-remove="${item.handle}" aria-label="${D.strings?.wishlistRemove || 'Remove'}">
            ${iconCloseSvg()}
          </button>
        </div>`
      )
      .join('');
  };

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      e.preventDefault();
      const list = loadWishlist();
      const handle = toggle.dataset.productHandle;
      const idx = list.findIndex((i) => i.handle === handle);
      if (idx >= 0) {
        list.splice(idx, 1);
      } else {
        list.push({
          handle,
          title: toggle.dataset.productTitle,
          price: Number(toggle.dataset.productPrice || 0),
          image: toggle.dataset.productImage || '',
          url: toggle.dataset.productUrl || '#'
        });
      }
      saveWishlist(list);
      updateWishlistUI();
      if (wishlistDrawer && wishlistDrawer.classList.contains('is-open')) {
        renderWishlist();
      }
      toggle.animate(
        [
          { transform: 'scale(0.6)' },
          { transform: 'scale(1.15)' },
          { transform: 'scale(1)' }
        ],
        { duration: 400, easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)' }
      );
      return;
    }

    const remove = e.target.closest('[data-wishlist-remove]');
    if (remove) {
      const list = loadWishlist().filter((i) => i.handle !== remove.dataset.wishlistRemove);
      saveWishlist(list);
      updateWishlistUI();
      renderWishlist();
    }
  });

  /* ---------- Helpers ---------- */
  const formatMoney = (cents) => {
    if (typeof cents !== 'number') return '';
    const value = (cents / 100).toLocaleString('fr-FR', { maximumFractionDigits: 0 });
    return `${value} €`;
  };

  const iconCloseSvg = () =>
    `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>`;

  window.DallasWishlist = {
    load: loadWishlist,
    save: saveWishlist,
    updateUI: updateWishlistUI,
    render: renderWishlist,
    open: openWishlist
  };

  document.addEventListener('DOMContentLoaded', () => {
    updateWishlistUI();
  });

  /* RTL arrow flip */
  document.addEventListener('DOMContentLoaded', () => {
    const html = document.documentElement;
    if (html.getAttribute('dir') === 'rtl') {
      $$('.icon-arrow').forEach((el) => {
        el.style.transform = 'scaleX(-1)';
      });
    }
  });
})();
